"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeConfiguration = normalizeConfiguration;
var SGWTConnectAuthorizationUri_1 = require("./SGWTConnectAuthorizationUri");
var SGWTConnectRedirectUri_1 = require("./SGWTConnectRedirectUri");
/**
 * Normalizes the configuration by adding default fields,
 * and normalizing existing fields.
 * @param config Configuration object to normalize.
 */
function normalizeConfiguration(config, location) {
    return __assign(__assign(__assign({}, config), { response_type: config.response_type || 'id_token token', acr_values: config.acr_values || 'L2', 
        // Normalize the authorization endpoint by stripping some
        // extraneous suffixes that users may add:
        authorization_endpoint: (0, SGWTConnectAuthorizationUri_1.normalizeAuthorizationEndpoint)(config.authorization_endpoint), 
        // API consumers may:
        //  - specify a redirect_uri relative to origin
        //    in this case we prefix it with origin
        //  - not specify a redirect_uri at all
        //    in this case we define it for them, as it is mandatory
        redirect_uri: (0, SGWTConnectRedirectUri_1.generateRedirectUri)(location, config.redirect_uri) }), (config.post_logout_redirect_uri
        ? { post_logout_redirect_uri: (0, SGWTConnectRedirectUri_1.generateRedirectUri)(location, config.post_logout_redirect_uri) }
        : {}));
}
//# sourceMappingURL=SGWTConnectConfiguration.js.map